import { render, staticRenderFns } from "./lk-breadcrumbs.vue?vue&type=template&id=546bff12&"
import script from "./lk-breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./lk-breadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-breadcrumbs/lk-breadcrumbs.vue
// module id = 105
// module chunks = 0